import React, { useState, useContext, useCallback, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  activateStudent,
  getCoins,
  getMe,
  initVoice,
  lessonResult, pingLesson,
  startLesson,
  initLibrary,
  startLibrary,
  initLibraryBook,
  submitLesson,
  submitLessonPractice,
  uploadToS3,
  watchLessonSubmission
} from '../../resources/api'
import UserContext from "../../context/UserContext";
const Pages = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currentSpread, setCurrentSpread] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [pages, setPages] = useState([]);
  const [bookData, setBookData] = useState(null);
  const [progressId, setProgressId] = useState(null);
  const { user } = useContext(UserContext);

  const [spreads, setSpreads] = useState([]);
  const [bookTitle, setBookTitle] = useState('');

  // Get book id from location.state
  const bookId = location.state?.book?.id;
  // const bookData = {"bookId": bookId};
  console.log('location state');
console.log(location.state);
  const nextPage = () => {
    if (currentPage < pages.length - 1) {
      setCurrentPage(currentPage + 1);
    } else {
      console.log(location.state);
      navigate('/quiz', { state: { quizzes: location.state.book.quizzes, book: location.state.book.content, progressId: progressId, bookTitle: bookTitle || '' } });
    }
  };

  const prevPage = () => {
    if (currentPage > 0 && currentPage < pages.length - 1) {
      setCurrentPage(currentPage - 1);
    } else {
      if (currentPage == pages.length - 1) {
        setCurrentPage(0)
      } else {
        navigate('/library');
      }
    }
  };

  const actionButtons = [
    {
      id: "Continue",
      onClick: () => {
        nextPage();
      },

      // navigate("/pages", { state: { book: location.state.book } }),
      text: currentPage == 0 ? "Next" : currentPage < pages.length - 1 ? "Next" : "Take Quiz",
      className:
        "shadow-[inset_0px_-4px_15px_#7fab81] bg-[linear-gradient(0deg,rgba(181,255,43,0)_0%,rgba(115,197,48,0.2)_100%),linear-gradient(0deg,rgba(170,224,22,1)_0%,rgba(170,224,22,1)_100%)]",
      preIcon: (
        <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_106_1605)">
            <path d="M28.3983 5.53888L11.1245 22.8114C11.0084 22.928 10.8704 23.0205 10.7184 23.0836C10.5664 23.1467 10.4035 23.1792 10.2389 23.1792C10.0743 23.1792 9.9114 23.1467 9.75942 23.0836C9.60744 23.0205 9.46943 22.928 9.35329 22.8114L2.67329 16.1251C2.55715 16.0085 2.41914 15.916 2.26716 15.8529C2.11518 15.7898 1.95223 15.7573 1.78767 15.7573C1.6231 15.7573 1.46015 15.7898 1.30817 15.8529C1.1562 15.916 1.01818 16.0085 0.902041 16.1251C0.785445 16.2413 0.69293 16.3793 0.629803 16.5313C0.566676 16.6832 0.53418 16.8462 0.53418 17.0108C0.53418 17.1753 0.566676 17.3383 0.629803 17.4902C0.69293 17.6422 0.785445 17.7802 0.902041 17.8964L7.58454 24.5776C8.28948 25.2813 9.24479 25.6764 10.2408 25.6764C11.2368 25.6764 12.1921 25.2813 12.897 24.5776L30.1695 7.30888C30.2859 7.19277 30.3783 7.05483 30.4413 6.90297C30.5043 6.7511 30.5368 6.5883 30.5368 6.42388C30.5368 6.25946 30.5043 6.09666 30.4413 5.9448C30.3783 5.79294 30.2859 5.655 30.1695 5.53888C30.0534 5.42229 29.9154 5.32977 29.7634 5.26664C29.6114 5.20352 29.4485 5.17102 29.2839 5.17102C29.1194 5.17102 28.9564 5.20352 28.8044 5.26664C28.6524 5.32977 28.5144 5.42229 28.3983 5.53888Z" fill="#374957" />
          </g>
          <defs>
            <clipPath id="clip0_106_1605">
              <rect width="30" height="30" fill="white" transform="translate(0.5)" />
            </clipPath>
          </defs>
        </svg>

      ),
      sufIcon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M28.9 12.3875L24.0625 7.5C23.9463 7.38284 23.808 7.28984 23.6557 7.22638C23.5034 7.16292 23.34 7.13025 23.175 7.13025C23.01 7.13025 22.8466 7.16292 22.6943 7.22638C22.542 7.28984 22.4037 7.38284 22.2875 7.5C22.0547 7.7342 21.924 8.05101 21.924 8.38125C21.924 8.71148 22.0547 9.02829 22.2875 9.2625L26.7375 13.75H1.25C0.918479 13.75 0.600537 13.8817 0.366117 14.1161C0.131696 14.3505 0 14.6685 0 15H0C0 15.3315 0.131696 15.6495 0.366117 15.8839C0.600537 16.1183 0.918479 16.25 1.25 16.25H26.8125L22.2875 20.7625C22.1703 20.8787 22.0773 21.017 22.0139 21.1693C21.9504 21.3216 21.9178 21.485 21.9178 21.65C21.9178 21.815 21.9504 21.9784 22.0139 22.1307C22.0773 22.283 22.1703 22.4213 22.2875 22.5375C22.4037 22.6547 22.542 22.7477 22.6943 22.8111C22.8466 22.8746 23.01 22.9072 23.175 22.9072C23.34 22.9072 23.5034 22.8746 23.6557 22.8111C23.808 22.7477 23.9463 22.6547 24.0625 22.5375L28.9 17.6875C29.6023 16.9844 29.9967 16.0312 29.9967 15.0375C29.9967 14.0437 29.6023 13.0906 28.9 12.3875Z" fill="#374957" />
        </svg>

      ),
    },
    {
      id: "Back",
      onClick: () => {
        prevPage();
      },
      // navigate("/library"),
      text: currentPage == 0 ? "Back" : currentPage < pages.length - 1 ? "Back" : "Read Again",
      className:
        "shadow-[inset_0px_-4px_15px_#edca92] bg-[linear-gradient(0deg,rgba(252,255,80,0)_0%,rgba(255,178,0,0.2)_100%),linear-gradient(0deg,rgba(255,238,192,1)_0%,rgba(255,238,192,1)_100%)]",
      icon: (
        currentPage < pages.length - 1 ?
          <svg width="31" height="30" viewBox="0 0 31 30" fill="none">
            <path
              d="M1.6 17.61L6.44 22.5C6.55 22.62 6.69 22.71 6.84 22.77C6.99 22.84 7.16 22.87 7.33 22.87C7.49 22.87 7.65 22.84 7.81 22.77C7.96 22.71 8.1 22.62 8.21 22.5C8.33 22.38 8.42 22.25 8.49 22.09C8.55 21.94 8.58 21.78 8.58 21.61C8.58 21.45 8.55 21.28 8.49 21.13C8.42 20.98 8.33 20.84 8.21 20.72L3.76 16.25H29.25C29.58 16.25 29.9 16.12 30.13 15.88C30.37 15.65 30.5 15.33 30.5 15C30.5 14.67 30.37 14.35 30.13 14.12C29.9 13.88 29.58 13.75 29.25 13.75H3.69L8.21 9.22C8.43 8.99 8.56 8.68 8.56 8.36C8.56 8.04 8.43 7.73 8.21 7.5C8.1 7.38 7.96 7.29 7.81 7.23C7.65 7.16 7.49 7.13 7.33 7.13C7.16 7.13 6.99 7.16 6.84 7.23C6.69 7.29 6.55 7.38 6.44 7.5L1.6 12.31C0.9 13.02 0.5 13.97 0.5 14.96C0.5 15.96 0.9 16.91 1.6 17.61Z"
              fill="#374957"
            />
          </svg> : <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_215_1305)">
              <path d="M15.5005 2.49986C17.1586 2.5053 18.7992 2.83953 20.3273 3.48321C21.8554 4.1269 23.2407 5.06725 24.403 6.24986H20.5005C20.169 6.24986 19.851 6.38155 19.6166 6.61597C19.3822 6.85039 19.2505 7.16834 19.2505 7.49986C19.2505 7.83138 19.3822 8.14932 19.6166 8.38374C19.851 8.61816 20.169 8.74986 20.5005 8.74986H25.6792C26.2948 8.74953 26.885 8.50486 27.3203 8.06961C27.7555 7.63437 28.0002 7.04414 28.0005 6.42861V1.24986C28.0005 0.918336 27.8688 0.600394 27.6344 0.365973C27.4 0.131553 27.082 -0.000143326 26.7505 -0.000143326C26.419 -0.000143326 26.101 0.131553 25.8666 0.365973C25.6322 0.600394 25.5005 0.918336 25.5005 1.24986V3.84736C23.4345 1.98667 20.8912 0.737869 18.1556 0.240793C15.42 -0.256283 12.6 0.0179966 10.0115 1.03292C7.42293 2.04784 5.16802 3.76332 3.49926 5.98726C1.83051 8.2112 0.8138 10.8558 0.562997 13.6249C0.546851 13.7989 0.567142 13.9745 0.622576 14.1403C0.67801 14.3061 0.767372 14.4585 0.884968 14.5878C1.00256 14.7172 1.14582 14.8206 1.30559 14.8916C1.46537 14.9625 1.63818 14.9994 1.813 14.9999C2.11873 15.0038 2.41492 14.8934 2.64357 14.6904C2.87223 14.4874 3.01689 14.2064 3.04925 13.9024C3.32751 10.7908 4.75921 7.89574 7.0631 5.7859C9.36698 3.67607 12.3765 2.50397 15.5005 2.49986Z" fill="#374957" />
              <path d="M29.1888 15.0002C28.883 14.9963 28.5868 15.1067 28.3582 15.3097C28.1295 15.5127 27.9849 15.7937 27.9525 16.0977C27.7459 18.4768 26.8612 20.7466 25.4033 22.638C23.9455 24.5294 21.9757 25.9629 19.7277 26.7684C17.4797 27.574 15.0477 27.7178 12.7204 27.1829C10.3931 26.6479 8.26812 25.4566 6.5975 23.7502H10.5C10.8315 23.7502 11.1495 23.6185 11.3839 23.3841C11.6183 23.1497 11.75 22.8318 11.75 22.5002C11.75 22.1687 11.6183 21.8508 11.3839 21.6164C11.1495 21.3819 10.8315 21.2502 10.5 21.2502H5.32125C5.01637 21.2501 4.71445 21.31 4.43275 21.4266C4.15105 21.5432 3.89509 21.7142 3.67951 21.9298C3.46393 22.1453 3.29296 22.4013 3.17636 22.683C3.05976 22.9647 2.99984 23.2666 3 23.5715V28.7503C3 29.0818 3.1317 29.3997 3.36612 29.6341C3.60054 29.8686 3.91848 30.0003 4.25 30.0003C4.58152 30.0003 4.89946 29.8686 5.13388 29.6341C5.3683 29.3997 5.5 29.0818 5.5 28.7503V26.1528C7.56604 28.0134 10.1093 29.2622 12.8449 29.7593C15.5805 30.2564 18.4005 29.9821 20.989 28.9672C23.5776 27.9523 25.8325 26.2368 27.5012 24.0128C29.17 21.7889 30.1867 19.1443 30.4375 16.3752C30.4536 16.2012 30.4334 16.0256 30.3779 15.8598C30.3225 15.694 30.2331 15.5416 30.1155 15.4122C29.9979 15.2829 29.8547 15.1794 29.6949 15.1085C29.5351 15.0376 29.3623 15.0007 29.1875 15.0002H29.1888Z" fill="#374957" />
            </g>
            <defs>
              <clipPath id="clip0_215_1305">
                <rect width="30" height="30" fill="white" transform="translate(0.5)" />
              </clipPath>
            </defs>
          </svg>

      ),
    },
  ];

  useEffect(() => {
    if (!bookId) return;
    window.soundManager.cleanAllChannel();
    initLibraryBook(bookId)
      .then(data => {
        console.log('book data')
        console.log(data)
        const apiPages = data?.data?.book?.content?.pages || [];
        setBookTitle(data?.data?.book?.title || '');
        setPages(apiPages);
      });
  }, [bookId]);

  useEffect(() => {
    if (!bookId) return;
    window.soundManager.cleanAllChannel();
    startLibrary({ "bookId": bookId })
      .then(data => {
        console.log('progress id');
        console.log(data.data.data);
        setProgressId(data.data.data);
      });
  }, []);


  // useEffect(() => {
  //   if (!bookId) return;
  //   window.soundManager.cleanAllChannel();
  //   initLibraryBook(bookId)
  //     .then(data => {
  //       console.log('datttta');
  //       console.log(data);
  //       // Extract pages from API response

  //       const pages = data?.data?.book?.content?.pages || [];
  //       setBookTitle(data?.data?.book?.title || '');
  //       setBookData(data?.data?.book || {});
  //       // Convert pages to spreads (left/right pages per spread)
  //       const formattedSpreads = [];
  //       for (let i = 0; i < pages.length; i += 2) {
  //         formattedSpreads.push({
  //           leftPage: {
  //             number: pages[i]?.pageNumber?.toString().padStart(2, '0') || '',
  //             content: pages[i]?.paragraphs?.map(p => p.text) || [],
  //             images: pages[i]?.images || []
  //           },
  //           rightPage: pages[i + 1]
  //             ? {
  //               number: pages[i + 1]?.pageNumber?.toString().padStart(2, '0') || '',
  //               content: pages[i + 1]?.paragraphs?.map(p => p.text) || [],
  //               images: pages[i + 1]?.images || []
  //             }
  //             : {
  //               number: '',
  //               content: [],
  //               images: []
  //             }
  //         });
  //       }
  //       setSpreads(formattedSpreads);
  //     });
  // }, [bookId]);

  if (!pages.length) {
    return (
      <div className="h-screen flex items-center justify-center bg-white">
        <span className="text-2xl text-[#3D74B6] font-bold">Loading...</span>
      </div>
    );
  }

  // If spreads not loaded yet, show loading
  // if (!spreads.length) {
  //   return (
  //     <div className="h-screen flex items-center justify-center bg-white">
  //       <span className="text-2xl text-[#3D74B6] font-bold">Loading...</span>
  //     </div>
  //   );
  // }

  // const spreads = [
  //   {
  //     leftPage: {
  //       number: "01",
  //       content: [
  //         "Have you ever raced to be first in line or tried to finish a test as fast as possible?",
  //         "It feels exciting to win, but is being first the most important thing?"
  //       ]
  //     },
  //     rightPage: {
  //       number: "02", 
  //       content: [
  //         "Some people always want to be first. They rush to finish their work, run to the front of the line, and make sure everyone knows they finished first.",
  //         "But sometimes, rushing can lead to mistakes, accidents, or missing important details. If you move too fast, you might trip, forget something, or not do your best work."
  //       ]
  //     }
  //   },
  //   {
  //     leftPage: {
  //       number: "03",
  //       content: [
  //         "What really matters isn't being first—it's doing your best. Imagine a runner in a race who takes their time to practice and improve.",
  //         "They may not win every race, but they keep getting stronger and faster. That's what success really looks like!"
  //       ]
  //     },
  //     rightPage: {
  //       number: "04",
  //       content: [
  //         "In school, it's not about finishing first—it's about understanding your work, learning new things, and improving each day.",
  //         "If you focus on being the best version of yourself, you will always be successful."
  //       ]
  //     }
  //   },
  //   {
  //     leftPage: {
  //       number: "05",
  //       content: [
  //         "Everyone moves at their own pace. Some people learn quickly, and others take more time, and that's okay!",
  //         "The goal is not to rush but to grow. When you take your time and work hard, you will feel proud of what you accomplish."
  //       ]
  //     },
  //     rightPage: {
  //       number: "06",
  //       content: [
  //         "So, next time you're doing an assignment, standing in line, or playing a game, ask yourself: Am I doing my best?",
  //         "If the answer is yes, then you are already a winner!"
  //       ]
  //     }
  //   }
  // ];

  // const nextPage = () => {
  //   if (currentPage < pages.length - 1) {
  //     setCurrentPage(currentPage + 1);
  //   } else {
  //     console.log(location.state);
  //     navigate('/quiz', { state: { quizzes: location.state.book.quizzes, book: location.state.book.content, progressId: progressId, bookTitle: location.state.book.title } });
  //   }
  // };

  // const prevPage = () => {

  //   if (currentPage > 0 && currentPage < pages.length - 1) {
  //     setCurrentPage(currentPage - 1);
  //   } else {
  //     if (currentPage == pages.length - 1) {
  //       setCurrentPage(0)
  //     } else {

  //       navigate('/library');
  //     }
  //   }
  // };

  const currentData = spreads[currentSpread];
  const pageData = pages[currentPage];
console.log(pages);
  return (
    <div className="h-screen w-screen overflow-hidden bg-white flex flex-col">
      {/* Header */}
      <header className="bg-[#3D74B6] shadow-lg">
        <div className="px-4 md:px-20 py-4">
          <h1 className="text-2xl md:text-4xl font-['Cheese_Matcha'] text-[#FBF5DE] text-center">
            {bookTitle}
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex flex-col items-center justify-center bg-[#FBF5DE] px-2 md:px-12 py-2 md:py-6">
        <div className="w-full max-w-7xl flex flex-col h-full justify-center">
          {/* Reading Spread Container */}
          <div className="bg-[#3D74B6] rounded-[40px] p-8 md:p-8 relative overflow-hidden flex-1 flex flex-col">
            {/* Background decorative circles */}
            {/* <div className="absolute inset-0">
              <div className="absolute top-20 right-32 w-64 h-64 bg-white/10 rounded-full"></div>
              <div className="absolute bottom-16 left-24 w-48 h-48 bg-white/10 rounded-full"></div>
              <div className="absolute top-1/2 left-1/3 w-32 h-32 bg-white/5 rounded-full"></div>
            </div> */}

            <div className="relative z-10 flex-1 flex flex-col">
              {/* Book Pages */}
              <div className="bg-[#E4E4E4] rounded-[20px] overflow-hidden flex-1 flex flex-row h-full min-h-[300px]">
                <div className="flex h-full w-full">
                  {/* Left Page */}
                  <div className="basis-3/4 bg-[#F2F2F2] relative flex flex-col h-full">
                    {/* Page Number */}
                    <div className="absolute top-4 left-4">
                      <span className="text-lg md:text-4xl font-['KG_Primary_Penmanship'] text-[#374957]">
                        {pageData.pageNumber?.toString().padStart(2, '0')}
                        {/* {currentData.leftPage.number} */}
                      </span>
                    </div>
                    {/* Images (if any) */}
                    {/* {currentData.leftPage.images?.length > 0 && (
                      <div className="px-24 pt-10">
                        {currentData.leftPage.images.map((img, idx) => (
                          <img
                            key={idx}
                            src={img.url}
                            alt={img.alt || ''}
                            className="w-full max-h-48 object-contain mb-4"
                          />
                        ))}
                      </div>
                    )} */}
                    {/* Content */}
                    <div className="flex-1 flex flex-col justify-center items-center px-14 md:px-18 py-64 md:py-12 lg:py-12 sm:py-12 overflow-auto hide-scrollbar"
                      style={{
                        maxHeight: "70vh",
                        scrollbarWidth: "none",           // Firefox
                        msOverflowStyle: "none"           // IE 10+
                      }}>
                      <style>
                        {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
                      </style>
                      <div className="space-y-4 md:space-y-12 w-full">
                        {/* {
                          user?.grade == 'K' || user?.grade == '1' ?  <p className="text-base md:text-3xl/10 font-['KG_Primary_Penmanship'] text-[#374957] ">
                          {pageData.paragraphs?.map(paragraph => paragraph.text).join(' ')}
                        </p>:
                        } */}
                        {(location.state.book.gradeLevel === '1' || location.state.book.gradeLevel === 1) ? (
  pageData.paragraphs?.map((paragraph, index) => (
    <p
      key={index}
      className="text-2xl md:text-4xl font-['KG_Primary_Penmanship'] text-[#374957] leading-relaxed"
    >
      {paragraph.text}
    </p>
  ))
) : (
  <p className="text-base md:text-3xl/10 font-['KG_Primary_Penmanship'] text-[#374957] ">
    {pageData.paragraphs?.map(paragraph => paragraph.text).join(' ')}
  </p>
)}
                        {/* <p className="text-base md:text-3xl/10 font-['KG_Primary_Penmanship'] text-[#374957] ">
                          {pageData.paragraphs?.map(paragraph => paragraph.text).join(' ')}
                        </p> */}
                        {/* {pageData.paragraphs?.map((paragraph, index) => (
                          <p
                            key={index}
                            className="text-base md:text-2xl font-['Cheese_Matcha'] text-[#374957] leading-relaxed"
                          >
                            {paragraph.text}
                          </p>
                        ))} */}
                        {/* {currentData.leftPage.content.map((paragraph, index) => (
                          <p
                            key={index}
                            className="text-base md:text-xl font-['Cheese_Matcha'] text-[#374957] leading-relaxed"
                          >
                            {paragraph}
                          </p>
                        ))} */}
                      </div>
                    </div>
                  </div>

                  {/* Divider */}
                  <div className="w-1 bg-gray-300"></div>

                  {/* Right Page */}
                  <div className="basis-1/4 bg-[#F2F2F2] relative flex flex-col h-full">
                    {/* Page Number */}
                    {/* <div className="absolute top-4 left-4">
                      <span className="text-lg md:text-4xl font-['Cheese_Matcha'] text-[#374957]">
                        {currentData.rightPage.number}
                      </span>
                    </div> */}
                    {/* Images (if any) */}
                    {/* {currentData.rightPage.images?.length > 0 && (
                      <div className="px-24 pt-10">
                        {currentData.rightPage.images.map((img, idx) => (
                          <img
                            key={idx}
                            src={img.url}
                            alt={img.alt || ''}
                            className="w-full max-h-48 object-contain mb-4"
                          />
                        ))}
                      </div>
                    )} */}
                    {/* Content */}
                    <div className="flex-1 flex flex-col justify-center items-center px-4 md:px-8 py-4 md:py-12 overflow-auto hide-scrollbar"
                      style={{
                        height: "100%",
                        scrollbarWidth: "none",           // Firefox
                        msOverflowStyle: "none"           // IE 10+
                      }}>
                      <style>
                        {`
      .hide-scrollbar::-webkit-scrollbar {
        display: none;
      }
    `}
                      </style>
                      <div className="space-y-4 md:space-y-10 w-full">
                        <nav
                          className="flex flex-col gap-6 w-full md:w-[300px] z-3"
                          role="navigation"
                          aria-label="Book actions"
                        >
                          {actionButtons.map((button) => (
                            <button
                              key={button.id}
                              onClick={button.onClick}
                              className={`flex items-center gap-4 px-6 py-4 ${button.className} text-[#374957] rounded-full text-xl md:text-2xl font-medium shadow-button hover:shadow-lg transition-all`}
                              type="button"
                              aria-label={button.text}
                            >
                              {currentPage == pages.length - 1 ? button.preIcon : null}
                              {button.icon}
                              <span>{button.text}</span>
                              {currentPage < pages.length - 1 ? button.sufIcon : null}
                            </button>
                          ))}
                        </nav>
                        {/* {currentData.rightPage.content.map((paragraph, index) => (
                          <p
                            key={index}
                            className="text-base md:text-xl font-['Cheese_Matcha'] text-[#374957] leading-relaxed"
                          >
                            {paragraph}
                          </p>
                        ))} */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Navigation Arrows */}


              {/* Page Progress Indicator */}
              {/* <div className="text-center mt-4">
                <div className="inline-flex gap-2">
                  {spreads.map((_, index) => (
                    <div 
                      key={index}
                      className={`w-3 h-3 rounded-full ${
                        index === currentSpread 
                          ? 'bg-white' 
                          : 'bg-white/50'
                      }`}
                    ></div>
                  ))}
                </div>
                <p className="mt-2 text-white text-lg font-['Cheese_Matcha']">
                  Spread {currentSpread + 1} of {spreads.length}
                </p>
              </div> */}
            </div>
          </div>
        </div>
      </main>
      {/* <div className="flex justify-between items-center mt-8 px-32 w-full fixed bottom-14 left-0 z-20">
                <button 
                  onClick={prevSpread}
                  className="w-16 h-16 bg-[#3D74B6] border-4 border-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
                
                <button 
                  onClick={nextSpread}
                  className="w-16 h-16 bg-[#3D74B6] border-4 border-white rounded-full flex items-center justify-center shadow-lg hover:bg-[#2d5a94] transition-colors"
                >
                  <svg className="w-8 h-8 text-white" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </div> */}
    </div>
  );
};

export default Pages;
